const API_BASE_URL = "https://logistics-tracking-api.nirnayanhealthcare.com"; // change to your server base url
// const API_BASE_URL = "http://localhost:5001"; 
export default API_BASE_URL;
